import React, { useState, useEffect, useRef } from "react";
import {
    Typography,
    IconButton,
    Box,
    Button,
    Chip,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    FormHelperText,
    TextField,
    Breadcrumbs,
    Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import { MascaraCep } from "../../../utils/MascaraCep";
import { TirarMascara } from "../../../utils/TirarMascara"

// Ícones
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import HomeIcon from '@mui/icons-material/Home';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

// Componentes personalizados
import HeaderDashboard from "../../components/HeaderDashboard";
import ModalNotificacao from "./ModalNotificacao";
import Loading from "../../components/Loading";

// Contexto
import { useUser } from "../../../contexts/UserContext";
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const campoSx = {
    "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" },
};

const linhaCamposSx = (colunas) => ({
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: colunas },
    gap: 1.5,
    alignItems: "start",
});

const botaoPrimarioSx = {
    textTransform: "none",
    fontSize: 14,
    fontWeight: 700,
    color: "#111827",
    backgroundColor: "#ffc845",
    borderRadius: "8px",
    boxShadow: "none",
    py: 1.1,
    "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" },
};

// Definido fora do componente para não remontar os inputs (e perder o foco) a cada render
const SecaoCard = ({ icone, titulo, descricao, children }) => (
    <Box sx={cardSx}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <Box
                sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "8px",
                    backgroundColor: "#f3f4f6",
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: 20 },
                }}
            >
                {icone}
            </Box>
            <Box>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>{titulo}</Typography>
                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{descricao}</Typography>
            </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>{children}</Box>
    </Box>
);

const Certificado = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    // Estados gerais
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [erroNomeFantasia, setErroNomeFantasia] = useState(false);
    const [hasCertificado, setHasCertificado] = useState(false);
    const [open, setOpen] = useState(false);
    const [certificadoName, setCertificadoName] = useState(null);
    const [razaoSocial, setRazaoSocial] = useState("");
    const [nomeFantasia, setNomeFantasia] = useState("");
    const [cep, setCep] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [estado, setEstado] = useState("");
    const [cidade, setCidade] = useState("");
    const [bairro, setBairro] = useState("");
    const [telefone, setTelefone] = useState("");
    const [checkboxFatura, setCheckboxFatura] = useState(false);
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");

    const [simplesNacional, setSimplesNacional] = useState('');
    const [regimeTributario, setRegimeTributario] = useState('');
    const [incentivoFiscal, setIncentivoFiscal] = useState(false);
    const [incentivoFiscalCultural, setIncentivoFiscalCultural] = useState(false);
    const [regimeTributarioEspecial, setRegimeTributarioEspecial] = useState('');

    const [erroCnpj, setErroCnpj] = useState(false);
    const [erroRazaoSocial, setErroRazaoSocial] = useState(false);
    const [erroSimplesNacional, setErroSimplesNacional] = useState(false);
    const [erroRegimeTributario, setErroRegimeTributario] = useState(false);
    const [erroRegimeTributarioEspecial, setErroRegimeTributarioEspecial] = useState(false);
    const [erroCep, setErroCep] = useState(false);
    const [erroInscricaoMunicipal, setErroInscricaoMunicipal] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [openSnackbarError, setOpenSnackbarError] = useState(false);

    // Campos de formulário
    const [email, setEmail] = useState("");
    const [file, setFile] = useState(null);
    const [senha, setSenha] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    // Campos de formulário
    const [cnpj, setCnpj] = useState("");

    // Drag & Drop
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);

    const token = localStorage.getItem("token");

    const mostrarErro = (texto) => {
        setMensagem(texto);
        setOpenSnackbarError(true);
    };

    const mostrarSucesso = (texto) => {
        setMensagem(texto);
        setOpenSnackbarSuccess(true);
    };

    // Busca e-mail do usuário logado
    useEffect(() => {
        if (user?.usuario?.Email) setEmail(user.usuario.Email);
    }, [user]);

    // Busca certificado ativo
    useEffect(() => {
        const getCertificado = async () => {
            setOpen(true);
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/getCertificado`, {
                    headers: { Authorization: token },
                });
                setHasCertificado(data.status === 200);
                if (data.status === 200) {
                    setCertificadoName(data.certificado.arquivoNome);
                }
            } catch (err) {
                console.error("Erro ao buscar certificado:", err);
                setHasCertificado(false);
            } finally {
                setOpen(false);
            }
        };

        getCertificado();
    }, [token]);

    useEffect(() => {
        const getDadosEmpresa = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/getDadosEmpresa`, {
                    headers: { Authorization: token },
                });
                if (response.data.status === 200) {
                    setCnpj(response.data.data.cnpj ? MascaraCnpj(response.data.data.cnpj) : "");
                    setInscricaoMunicipal(response.data.data.inscricaoMunicipal || "");
                    setInscricaoEstadual(response.data.data.inscricaoEstadual || "");
                    setRazaoSocial(response.data.data.razaoSocial || "");
                    setNomeFantasia(response.data.data.nomeFantasia || "");
                    setCep(response.data.data.cep || "");
                    setEndereco(response.data.data.logradouro || "");
                    setNumero(response.data.data.numero || "");
                    setEstado(response.data.data.estado || "");
                    setCidade(response.data.data.cidade || "");
                    setBairro(response.data.data.bairro || "");
                    setTelefone(response.data.data.telefone ? MascaraTelefone(response.data.data.telefone) : "");
                    setRegimeTributarioEspecial(response.data.data.regimeTributarioEspecial !== undefined ? response.data.data.regimeTributarioEspecial : false);
                    setSimplesNacional(response.data.data.simplesNacional !== undefined ? response.data.data.simplesNacional : false);
                    setRegimeTributario(response.data.data.regimeTributario !== undefined ? response.data.data.regimeTributario : false);
                    setIncentivoFiscal(response.data.data.incentivoFiscal !== undefined ? response.data.data.incentivoFiscal : false);
                    setIncentivoFiscalCultural(response.data.data.incentivadorCultural !== undefined ? response.data.data.incentivadorCultural : false);
                    setCheckboxFatura(response.data.data.gerarFaturas || false);
                }
            } catch (err) {
                console.error("Erro ao buscar dados da empresa:", err);
            }
        };
        getDadosEmpresa();
    }, [token]);

    // Funções de drag and drop
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFile = e.dataTransfer.files[0];
        validateFile(droppedFile);
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.target.files[0];
        validateFile(selectedFile);
    };

    const validateFile = (file) => {
        if (file && (file.name.endsWith(".pfx") || file.name.endsWith(".p12"))) {
            setFile(file);
        } else {
            mostrarErro("Por favor, selecione um arquivo .pfx ou .p12 válido.");
        }
    };

    // Controle da visibilidade da senha
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => event.preventDefault();

    // Envio do certificado
    const handleSubmit = async () => {
        if (!file) return mostrarErro("Selecione um arquivo de certificado.");
        if (!senha) return mostrarErro("Digite a senha do certificado.");

        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("senha", senha);
        formData.append("email", email);

        try {
            setOpen(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/uploadCertificado`, formData, {
                headers: {
                    Authorization: token,
                    "Content-Type": "multipart/form-data",
                },
            });
            if (data.status === 200) {
                mostrarSucesso("Certificado atualizado com sucesso!");
                setHasCertificado(true);
                setCertificadoName(data.nomeArquivo);
                setFile(null);
                setSenha("");
            } else {
                mostrarErro(data.message || "Falha ao atualizar certificado. Verifique os dados e tente novamente.");
            }
        } catch (err) {
            console.error(err);
            mostrarErro("Erro ao enviar o certificado. Tente novamente mais tarde.");
        } finally {
            setOpen(false);
        }
    };

    const handleCnpj = async (e) => {
        setCnpj(MascaraCnpj(e.target.value));
        if (e.target.value.length === 18) {
            setOpen(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/buscarCnpj/${TirarMascara(e.target.value)}`, {
                    headers: { Authorization: token },
                });
                if (response.data.status === 200) {
                    setRazaoSocial(response.data.data.razao_social);
                    setNomeFantasia(response.data.data.nome);
                    setCep(response.data.data.endereco.cep);
                    setEndereco(response.data.data.endereco.logradouro);
                    setNumero(response.data.data.endereco.numero);
                    setEstado(response.data.data.endereco.uf);
                    setCidade(response.data.data.endereco.municipio);
                    setBairro(response.data.data.endereco.bairro);
                    setTelefone(response.data.data.telefone);
                } else {
                    mostrarErro("CNPJ não encontrado.");
                }
            } catch (err) {
                console.error("Erro ao buscar CNPJ:", err);
                mostrarErro("Erro ao buscar CNPJ. Tente novamente mais tarde.");
            } finally {
                setOpen(false);
            }
        }
    }

    const handleSubmitCompany = async () => {
        let isValid = true;
        if (cnpj.length !== 18) {
            isValid = false;
            setErroCnpj(true);
        } else {
            setErroCnpj(false);
        }

        if (razaoSocial.trim() === "") {
            isValid = false;
            setErroRazaoSocial(true);
        } else {
            setErroRazaoSocial(false);
        }

        if (simplesNacional === "") {
            isValid = false;
            setErroSimplesNacional(true);
        } else {
            setErroSimplesNacional(false);
        }

        if (nomeFantasia.trim() === "") {
            isValid = false;
            setErroNomeFantasia(true);
        } else {
            setErroNomeFantasia(false);
        }

        if (inscricaoMunicipal.trim() === "") {
            isValid = false;
            setErroInscricaoMunicipal(true);
        } else {
            setErroInscricaoMunicipal(false);
        }

        if (regimeTributario === "") {
            isValid = false;
            setErroRegimeTributario(true);
        } else {
            setErroRegimeTributario(false);
        }

        if (regimeTributarioEspecial === "") {
            isValid = false;
            setErroRegimeTributarioEspecial(true);
        } else {
            setErroRegimeTributarioEspecial(false);
        }

        if (cep.trim() === "" || cep.length < 8) {
            isValid = false;
            setErroCep(true);
        } else {
            setErroCep(false);
        }

        if (!isValid) {
            mostrarErro("Preencha os campos obrigatórios destacados.");
            return;
        }

        setOpen(true);
        const objetoReq = {
            empresa: {
                cnpj: TirarMascara(cnpj),
                inscricaoMunicipal,
                razaoSocial,
                nomeFantasia,
                simplesNacional,
                regimeTributario,
                incentivoFiscal,
                incentivadorCultural: incentivoFiscalCultural,
                regimeTributarioEspecial,
                cep: TirarMascara(cep),
                logradouro: endereco,
                numero,
                bairro,
                cidade,
                estado,
                email,
                telefone: telefone ? TirarMascara(telefone) : "",
            },
            gerarFaturas: checkboxFatura,
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/salvarDadosEmpresa`, objetoReq, {
                headers: { Authorization: token },
            });
            if (response.data.status === 200) {
                mostrarSucesso(response.data.mensagem || "Dados da empresa salvos com sucesso!");
            } else {
                console.log(response.data);
                mostrarErro(response.data.message || "Falha ao salvar os dados da empresa. Verifique os dados e tente novamente.");
            }
        } catch (err) {
            console.error("Erro ao salvar dados da empresa:", err);
            mostrarErro("Erro ao salvar os dados da empresa. Tente novamente mais tarde.");
        } finally {
            setOpen(false);
        }
    }

    return (
        <>
            <HeaderDashboard
                userActive={userActive}
                setOpenModalNotificacao={setOpenModalNotificacao}
                notificacoes={notificacoes.length}
            />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <ArtTrackIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Certificado & Empresa
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Certificado & Empresa
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Envie seu certificado digital e configure os dados da empresa para emitir notas fiscais.
                        </Typography>
                    </Box>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("../Dashboard")}
                        sx={{ alignSelf: { xs: "flex-start", md: "center" }, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                    >
                        Voltar
                    </Button>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1.3fr) minmax(0, 2.7fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    {/* Certificado digital */}
                    <Box sx={{ ...cardSx, position: { md: "sticky" }, top: { md: 80 } }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 2 }}>
                            <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Certificado Digital</Typography>
                            <Chip
                                label={hasCertificado ? "Ativo" : "Pendente"}
                                size="small"
                                sx={{
                                    backgroundColor: hasCertificado ? "#dcfce7" : "#fee2e2",
                                    color: hasCertificado ? "#15803d" : "#b91c1c",
                                    fontWeight: 700,
                                    fontSize: 10,
                                    height: 20,
                                    letterSpacing: 0.5,
                                    textTransform: "uppercase",
                                }}
                            />
                        </Box>

                        {hasCertificado ? (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, backgroundColor: "#0b243d", borderRadius: "10px", p: 1.5, mb: 2 }}>
                                <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "rgba(255, 255, 255, 0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <VerifiedUserIcon sx={{ fontSize: 20, color: "#ffc845" }} />
                                </Box>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Certificado ativo</Typography>
                                    <Typography noWrap sx={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>{certificadoName}</Typography>
                                </Box>
                            </Box>
                        ) : (
                            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, backgroundColor: "#fee2e2", color: "#b91c1c", borderRadius: "10px", p: 1.5, mb: 2 }}>
                                <GppMaybeOutlinedIcon sx={{ fontSize: 20 }} />
                                <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                                    Você não possui um certificado digital ativo. Envie seu certificado para liberar a emissão de notas.
                                </Typography>
                            </Box>
                        )}

                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#374151", mb: 1 }}>
                            {hasCertificado ? "Atualizar certificado (.pfx ou .p12)" : "Arquivo do certificado (.pfx ou .p12)"}
                        </Typography>
                        <Box
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current.click()}
                            sx={{
                                border: "2px dashed",
                                borderColor: isDragging ? "#ffc845" : file ? "#86efac" : "#d1d5db",
                                borderRadius: "10px",
                                p: 3,
                                textAlign: "center",
                                cursor: "pointer",
                                backgroundColor: isDragging ? "#fffbeb" : file ? "#f0fdf4" : "#f9fafb",
                                transition: "all 0.2s ease",
                                "&:hover": { borderColor: "#ffc845" },
                            }}
                        >
                            {file ? (
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                                    <InsertDriveFileOutlinedIcon sx={{ fontSize: 32, color: "#16a34a" }} />
                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827", wordBreak: "break-all" }}>{file.name}</Typography>
                                    <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Clique para trocar o arquivo</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                                    <CloudUploadOutlinedIcon sx={{ fontSize: 32, color: "#9ca3af" }} />
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>
                                        Arraste e solte o arquivo aqui
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                        ou <Box component="span" sx={{ fontWeight: 700, color: "#111827", textDecoration: "underline" }}>procure no computador</Box>
                                    </Typography>
                                </Box>
                            )}
                            <input
                                type="file"
                                accept=".pfx,.p12"
                                ref={fileInputRef}
                                onChange={handleFileSelect}
                                style={{ display: "none" }}
                            />
                        </Box>

                        {/* Senha do certificado */}
                        <FormControl sx={{ mt: 2, ...campoSx }} fullWidth size="small" variant="outlined" autoComplete="off">
                            <InputLabel htmlFor="outlined-adornment-password">Senha do Certificado</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                name="fakepassword"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                placeholder="Digite a senha do seu certificado"
                                type={showPassword ? "text" : "password"}
                                autoComplete="new-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                            aria-label="toggle password visibility"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Senha do Certificado"
                            />
                            <FormHelperText>
                                A senha é necessária para validar o arquivo do certificado.
                            </FormHelperText>
                        </FormControl>

                        {/* E-mail */}
                        <FormControl sx={{ mt: 2, ...campoSx }} fullWidth size="small" variant="outlined">
                            <InputLabel htmlFor="email-notificacao">E-mail para notificação</InputLabel>
                            <OutlinedInput
                                id="email-notificacao"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Digite seu e-mail"
                                type="email"
                                autoComplete="off"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <EmailIcon sx={{ color: "#9ca3af" }} />
                                    </InputAdornment>
                                }
                                label="E-mail para notificação"
                            />
                            <FormHelperText>
                                Enviaremos notificações para este e-mail quando o certificado estiver próximo do vencimento.
                            </FormHelperText>
                        </FormControl>

                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<CloudUploadOutlinedIcon />}
                            sx={{ ...botaoPrimarioSx, mt: 3 }}
                            onClick={handleSubmit}
                        >
                            {hasCertificado ? "Atualizar Certificado" : "Enviar Certificado"}
                        </Button>
                    </Box>

                    {/* Dados da empresa */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {!hasCertificado && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, backgroundColor: "#fef3c7", border: "1px solid #fde68a", borderRadius: "12px", px: 2, py: 1.5, color: "#b45309" }}>
                                <LockOutlinedIcon sx={{ fontSize: 20 }} />
                                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                    Antes de preencher os dados da empresa, é necessário cadastrar um certificado digital ativo.
                                </Typography>
                            </Box>
                        )}

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                opacity: hasCertificado ? 1 : 0.5,
                                pointerEvents: hasCertificado ? "auto" : "none",
                                userSelect: hasCertificado ? "auto" : "none",
                            }}
                            aria-disabled={!hasCertificado}
                        >
                            <SecaoCard icone={<BusinessIcon />} titulo="Identificação" descricao="Campos marcados com (*) são obrigatórios">
                                <TextField fullWidth size="small" error={erroCnpj} value={cnpj} onChange={e => handleCnpj(e)} label="CNPJ da Empresa" variant="outlined" required helperText="Com o CNPJ completo, os dados são preenchidos automaticamente" placeholder="00.000.000/0000-00" autoComplete="off" sx={campoSx} />
                                <Box sx={linhaCamposSx("1fr 1fr")}>
                                    <TextField fullWidth disabled value={inscricaoEstadual} onChange={e => setInscricaoEstadual(e.target.value)} size="small" label="Inscrição estadual" variant="outlined" autoComplete="off" sx={campoSx} />
                                    <TextField fullWidth required error={erroInscricaoMunicipal} value={inscricaoMunicipal} onChange={e => setInscricaoMunicipal(e.target.value)} size="small" label="Inscrição municipal" variant="outlined" autoComplete="off" sx={campoSx} />
                                </Box>
                                <TextField fullWidth size="small" label="Razão Social da Empresa" error={erroRazaoSocial} value={razaoSocial} onChange={e => setRazaoSocial(e.target.value)} variant="outlined" required autoComplete="off" sx={campoSx} />
                                <TextField fullWidth size="small" label="Nome Fantasia da Empresa" error={erroNomeFantasia} value={nomeFantasia} onChange={e => setNomeFantasia(e.target.value)} variant="outlined" required autoComplete="off" sx={campoSx} />
                            </SecaoCard>

                            <SecaoCard icone={<AccountBalanceOutlinedIcon />} titulo="Tributação" descricao="Enquadramento fiscal da empresa">
                                <Box sx={linhaCamposSx("1fr 1fr 1fr")}>
                                    <FormControl error={erroSimplesNacional} fullWidth size="small" required sx={campoSx}>
                                        <InputLabel id="simples-nacional-label">Simples Nacional</InputLabel>
                                        <Select
                                            labelId="simples-nacional-label"
                                            value={simplesNacional}
                                            label="Simples Nacional"
                                            onChange={e => setSimplesNacional(e.target.value)}
                                        >
                                            <MenuItem value={true}>Sim</MenuItem>
                                            <MenuItem value={false}>Não</MenuItem>
                                        </Select>
                                        <FormHelperText>Empresa é do Simples Nacional?</FormHelperText>
                                    </FormControl>
                                    <FormControl error={erroRegimeTributario} fullWidth size="small" required sx={campoSx}>
                                        <InputLabel id="regime-tributario-label">Regime Tributário</InputLabel>
                                        <Select
                                            labelId="regime-tributario-label"
                                            value={regimeTributario}
                                            label="Regime Tributário"
                                            onChange={e => setRegimeTributario(e.target.value)}
                                        >
                                            <MenuItem value={0}>Nenhum</MenuItem>
                                            <MenuItem value={1}>Simples Nacional</MenuItem>
                                            <MenuItem value={2}>Simples Nacional - Excesso</MenuItem>
                                            <MenuItem value={3}>Regime Normal - Lucro Presumido</MenuItem>
                                            <MenuItem value={4}>Normal - Lucro Real</MenuItem>
                                            <MenuItem value={5}>MEI (Microempreendedor individual)</MenuItem>
                                        </Select>
                                        <FormHelperText>Regime tributário da empresa</FormHelperText>
                                    </FormControl>
                                    <FormControl fullWidth size="small" sx={campoSx}>
                                        <InputLabel id="incentivo-fiscal-label">Incentivo Fiscal</InputLabel>
                                        <Select
                                            labelId="incentivo-fiscal-label"
                                            value={incentivoFiscal}
                                            label="Incentivo Fiscal"
                                            onChange={e => setIncentivoFiscal(e.target.value)}
                                        >
                                            <MenuItem value={true}>Sim</MenuItem>
                                            <MenuItem value={false}>Não</MenuItem>
                                        </Select>
                                        <FormHelperText>Possui incentivo fiscal?</FormHelperText>
                                    </FormControl>
                                </Box>
                                <Box sx={linhaCamposSx("1fr 1fr")}>
                                    <FormControl fullWidth size="small" sx={campoSx}>
                                        <InputLabel id="incentivo-cultural-label">Incentivo Fiscal Cultural</InputLabel>
                                        <Select
                                            labelId="incentivo-cultural-label"
                                            value={incentivoFiscalCultural}
                                            label="Incentivo Fiscal Cultural"
                                            onChange={e => setIncentivoFiscalCultural(e.target.value)}
                                        >
                                            <MenuItem value={true}>Sim</MenuItem>
                                            <MenuItem value={false}>Não</MenuItem>
                                        </Select>
                                        <FormHelperText>Possui incentivo fiscal cultural?</FormHelperText>
                                    </FormControl>
                                    <FormControl fullWidth error={erroRegimeTributarioEspecial} size="small" required sx={campoSx}>
                                        <InputLabel id="regime-especial-label">Regime tributário Especial</InputLabel>
                                        <Select
                                            labelId="regime-especial-label"
                                            value={regimeTributarioEspecial}
                                            label="Regime tributário Especial"
                                            onChange={e => setRegimeTributarioEspecial(e.target.value)}
                                        >
                                            <MenuItem value={0}>Sem Regime Tributário Especial</MenuItem>
                                            <MenuItem value={1}>Micro Empresa Municipal</MenuItem>
                                            <MenuItem value={2}>Estimativa</MenuItem>
                                            <MenuItem value={3}>Sociedade de Profissionais</MenuItem>
                                            <MenuItem value={4}>Cooperativa</MenuItem>
                                            <MenuItem value={5}>Microempresário Individual - MEI</MenuItem>
                                            <MenuItem value={6}>Microempresa ou Pequeno Porte - ME EPP</MenuItem>
                                            <MenuItem value={7}>Lucro Real</MenuItem>
                                            <MenuItem value={8}>Lucro Presumido</MenuItem>
                                            <MenuItem value={9}>Tributação Normal</MenuItem>
                                            <MenuItem value={10}>Simples nacional com excesso do sublimite</MenuItem>
                                            <MenuItem value={11}>Empresa de Responsabilidade Limitada</MenuItem>
                                        </Select>
                                        <FormHelperText>Possui regime tributário especial?</FormHelperText>
                                    </FormControl>
                                </Box>
                            </SecaoCard>

                            <SecaoCard icone={<LocationOnOutlinedIcon />} titulo="Endereço e contato" descricao="Endereço fiscal e canais de contato da empresa">
                                <Box sx={linhaCamposSx("1fr 2fr 0.7fr")}>
                                    <TextField fullWidth error={erroCep} required value={MascaraCep(cep)} onChange={e => setCep(e.target.value)} size="small" label="CEP" variant="outlined" autoComplete="off" sx={campoSx} />
                                    <TextField fullWidth required value={endereco} onChange={e => setEndereco(e.target.value)} size="small" label="Endereço" variant="outlined" autoComplete="off" sx={campoSx} />
                                    <TextField fullWidth required value={numero} onChange={e => setNumero(e.target.value)} size="small" label="Número" variant="outlined" autoComplete="off" sx={campoSx} />
                                </Box>
                                <Box sx={linhaCamposSx("1fr 1fr 1fr")}>
                                    <TextField fullWidth required value={estado} onChange={e => setEstado(e.target.value)} size="small" label="Estado" variant="outlined" autoComplete="off" sx={campoSx} />
                                    <TextField fullWidth required value={cidade} onChange={e => setCidade(e.target.value)} size="small" label="Cidade" variant="outlined" autoComplete="off" sx={campoSx} />
                                    <TextField fullWidth required value={bairro} onChange={e => setBairro(e.target.value)} size="small" label="Bairro" variant="outlined" autoComplete="off" sx={campoSx} />
                                </Box>
                                <Box sx={linhaCamposSx("1.5fr 1fr")}>
                                    <TextField fullWidth required value={email} onChange={e => setEmail(e.target.value)} size="small" label="E-mail da Empresa" variant="outlined" autoComplete="off" sx={campoSx} />
                                    <TextField fullWidth value={telefone} onChange={e => setTelefone(MascaraTelefone(e.target.value))} size="small" label="Telefone da empresa" variant="outlined" autoComplete="off" sx={campoSx} />
                                </Box>
                            </SecaoCard>

                            <Box
                                sx={{
                                    ...cardSx,
                                    p: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1.5,
                                    flexWrap: "wrap",
                                }}
                            >
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={checkboxFatura} onChange={e => setCheckboxFatura(e.target.checked)} sx={{ "&.Mui-checked": { color: "#0b243d" } }} />}
                                    label="Gerar as faturas para este CNPJ?"
                                    sx={{ mr: 0, "& .MuiFormControlLabel-label": { fontSize: 13, color: "#374151" } }}
                                />
                                <Button
                                    variant="contained"
                                    startIcon={<SaveOutlinedIcon />}
                                    sx={{ ...botaoPrimarioSx, px: 3, width: { xs: "100%", sm: "auto" } }}
                                    onClick={handleSubmitCompany}
                                >
                                    Salvar Dados da Empresa
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <Loading open={open} />
            <AlertSuccess setOpenSnackbarSuccess={setOpenSnackbarSuccess} openSnackbarSuccess={openSnackbarSuccess} mensagem={mensagem} />
            <AlertError setOpenSnackbarError={setOpenSnackbarError} openSnackbarError={openSnackbarError} mensagem={mensagem} />
        </>
    );
};

export default Certificado;
